export let imgname= 
[ '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20'
  // 'cute_chopter',
  // 'ninja_adventure_2',
  // 'santa_snow_runner',
  // 'skyscraper',
  // 'cut_fruit',
  // 'ninja_jump_and_fun',
  // 'stacking_colors',
  // 'cat_strapped',
  // 'leap_and_jump_3',
  // 'jump_box_hero',
  // 'dark_world',
  // 'flapcat_christmas',
  // 'east_runner',
  // 'cycle_extreme',
  // 'rabbit_run',
  // 'crazy_knife',
  // 'cut_the_rope_2',
  // 'beach_bowling_3d',
  // 'bullet_bender',
  // 'craneitup',
  // 'd._copter_reloaded',
  // 'hopscotch',
  // 'knives',
  // 'dual_control_racing',
  // 'daddy_rabbit',
  // 'bouncy_dunk',
  // 'gt_ghost_racing',
  // 'tac_tac_way',
  // 'king_of_thieves',
  // 'snake_brawl',
  // 'parking_space',
  // 'panda_fight',
  // 'russian_car_drift_3d',
  // 'ontube',
  // 'playful_kitty',
  // 'rabbit_samurai_2',
  // 'road_of_the_dead',
  // 'master_checkers',
  // 'ludo',
  // 'moto_maniac',
  // 'top_shootout',
  // 'the_world_of_bob',
  // 'zombie_cant_jump',
  // 'popup',
  // 'bomber_friends',
  // 'wall_breaker',
  // 'mr_wick_one_bullet',
  // 'sprint_club_nitro',
  // 'dropme',
  // 'ufo_run',
  // 'space_miner',
  // 'ocean_crash',
  // 'penalty_shooters',
  // 'tic_tac_toe_html5',
  // 'evil_wyrm',
  // 'flappy_wow',
  // 'octane_racing',
  // 'cheese_lab',
  // 'bubble_shooter_hd',
  // 'monsterjong',
  // 'shapes',
  // 'mini_putt_garden',
  // 'harry_down',
  // 'little_bouncing_guys',
  // 'yeti_sensation',
  // 'badland',
  // 'street_freekick_3d',
  // 'swipy_basketball',
  // 'sweet_monsters'
];